
import { IContractTemplateForm, IDistributionMutation } from 'services/templates/types';
import { separateTemplateTreeItems } from '../templateFormItemsSeparator';

export const digitalDistributionTemplateFormToQuery = (
  contract: IContractTemplateForm
): IDistributionMutation | null => {
  const { digitalDistribution } = separateTemplateTreeItems(
    contract.items[0].children
  );

  return digitalDistribution ?? null;
};
